<script lang="ts" setup>
import { ApiAssistanceServices } from '~~/server/api/insurance/assistance-services'

const route = useRoute()
const { data: page, redirect } = await useFetchWithRedirect<ApiAssistanceServices>(
    '/api/insurance/assistance-services',
    { route }
)

if(redirect && !redirect?.error) {
    navigateTo(redirect.data.url, redirect.data.options)
}

// Schema.org
useSchemaOrg([
    defineWebPage({
        name: page.value?.data.title,
        image: page.value?.data.headline.image.path['1540x0']?.url || '',
    }),
])

// Page meta
usePageMeta({
    meta: page.value?.data.meta,
    title: page.value?.data.title,
    og_type: 'product'
})
</script>
<template>
  <article v-if="page">
    <ContainerFluid>
      <Breadcrumbs
        :current="page.data.title"
        :links="[]"
      />
    </ContainerFluid>
    <PageHeader
      :title="page.data.title"
      :subtitle="page.data.subtitle"
      :headline="page.data.headline"
      :cta="page.data.headline.cta"
      class="mb-12 mb-md-20"
    />
    <ContainerFluid>
      <PagesAssistenceServicesFavorite
        class="mb-12 mb-md-20"
        :data="page.data.favorites"
      />
      <LazyPagesAssistenceServicesLinks
        class="mb-12 mb-md-20 scroll-margin-top-10"
        :data="page.data.groups"
      />
      <LazyPagesAssistenceServicesTestimonials
        class="mb-12 mb-md-20"
        :data="page.data.testimonials"
      />
    </ContainerFluid>
  </article>
</template>
